import { render } from "./FacilityDetails.vue?vue&type=template&id=2b75d308&scoped=true&ts=true"
import script from "./FacilityDetails.vue?vue&type=script&lang=ts"
export * from "./FacilityDetails.vue?vue&type=script&lang=ts"

import "./FacilityDetails.vue?vue&type=style&index=0&id=2b75d308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b75d308"]])

export default __exports__